/**
 * Theme mode.
 *
 * @public
 */
export type ThemeMode = 'dark' | 'light';

/**
 * Available theme modes.
 *
 * @public
 */
export const THEME_MODES: ReadonlyArray<ThemeMode> = ['dark', 'light'] as const;

/**
 * Theme mode with system option.
 *
 * @public
 */
export type ThemeModeWithSystem = ThemeMode | 'system';

/**
 * Available theme modes including system option.
 *
 * @public
 */
export const THEME_MODES_WITH_SYSTEM: ReadonlyArray<ThemeModeWithSystem> = ['dark', 'light', 'system'] as const;
